import axios from 'axios';
import headers from "../Header";

let baseUrl = "/sdpi/kuesioner"

class KuesionerService {
    download(nomor_kk) {
        return axios.get(baseUrl + "/download?nomor_kk=" + nomor_kk, {
            headers: headers(), responseType: 'blob',
        });
    }

    generate(kode_sls, nomor_kk) {
        return axios.get(baseUrl + "?kode_sls="+kode_sls+"&nomor_kk=" + nomor_kk, {
            headers: headers()
        });
    }

    generateKkTidakValid(kode_sls, nama) {
        return axios.get(baseUrl + "/kk-tidak-valid?kode_sls="+kode_sls+"&nama=" + nama, {
            headers: headers()
        });
    }

}

export default new KuesionerService();